export const DEFAULT_WORKSPACE_NAME = "default";

export const DEFAULT_USERNAME = "default";
export const isDefaultUser = (userName: string) =>
  userName === DEFAULT_USERNAME;
